import axios from "axios";
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify"
import Cookies from 'js-cookie'
import SyncLoader from "react-spinners/SyncLoader";
import { css } from "@emotion/react";
import { Form, FormGroup, FormFeedback, Input, Label } from "reactstrap";
import { queryByDisplayValue } from "@testing-library/dom";
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from 'moment';


const EditQueryStatusForm = () => {

    const history = useHistory();
    const [query, setQuery] = useState();
    const { queryId } = useParams();
    const [loading, setLoading] = useState(false);
    const [disable, setDisable] = useState(false)
    const [color, setColor] = useState("#ffffff");
    const [status, setStatus] = useState();

    const override = css`
      display: block;
      margin: 0 auto;
      border-color: red;
    `;

    const callback = () => {
        setLoading(false);
        setDisable(false);
    }

    useEffect(() => {
        setLoading(true);
        fetchQuery(queryId);
        console.log("query: ", query);
    }, [])

    useEffect(() => {
        setStatus(query?.status);
    }, [query])


    /** State */
    const fetchQuery = async (id) => {
        const response = await axios.request({
            headers: {
                'Content-Type': 'application/json',
                'Authorization': Cookies.get('token')
            },
            method: 'get',
            url: `${process.env.REACT_APP_SERVER_URL}/v1/cms/get-query-by-id?id=${id}`
        });
        setQuery(response.data);
        callback();
    }

    const handleOnStatusChange = (e) => {
        setStatus(e.target.value);
    }

    const onSubmit = async (e) => {
        e.preventDefault()
        try {
            setLoading(true)
            setDisable(true);
            if (status === query?.status)
                toast.error("status was unchanged!");
            else {
                const response = await axios.request({
                    data: { id: queryId, status, prevStatus: query?.status, email: query?.email },
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': Cookies.get('token')
                    },
                    method: 'put',
                    url: `${process.env.REACT_APP_SERVER_URL}/v1/cms/edit-contact-us-query-status`
                })
                if (response.data.success) {
                    toast.success(response.data.message);
                    history.push("/contact-us-queries");
                }
                else {
                    toast.error("Something went wrong");
                }
            }
            callback();
        }
        catch (error) {
            toast.error(error)
            callback();
        }
    };

    return (
        <>
            <div className="dashContentHeader px-5 mb-3 row">
                <h5 className="dashHeading mb-0 fontfammedium p-0">
                    Edit Query Status
                </h5>
            </div>
            <div className="row dashboardCardRow px-5">
                <div className="col-lg-8 bg-white mt-5 shadow">
                    <form className="mg-login new-product mt-4 px-3" onSubmit={onSubmit}>
                        <div className="row mb-0">
                            <div className="col-md-6">
                                <FormGroup className="form-group">
                                    <Label for="first-name" className="form-label text-uppercase">First Name</Label>
                                    <Input id="first-name" name="first-name" className="form-control" type="text" value={query?.firstName} disabled />
                                </FormGroup>
                            </div>
                            <div className="col-md-6">
                                <FormGroup className="form-group">
                                    <Label for="last-name" className="form-label text-uppercase">Last Name</Label>
                                    <Input id="last-name" name="last-name" className="form-control" type="text" value={query?.lastName} disabled />

                                </FormGroup>
                            </div>
                            <div className="col-md-12">
                                <FormGroup className="form-group">
                                    <Label for="email" className="form-label text-uppercase">Email</Label>
                                    <Input id="email" name="email" className="form-control" type="email" value={query?.email} disabled />
                                </FormGroup>
                            </div>
                            <div className="col-md-6">
                                <FormGroup className="form-group">
                                    <Label for="phone" className="form-label text-uppercase">Phone</Label>
                                    <Input id="phone" name="phone" className="form-control" type="tel" value={query?.phone} disabled />
                                </FormGroup>
                            </div>
                            <div className="col-md-6">
                                <FormGroup className="form-group">
                                    <Label for="pref-time" className="form-label text-uppercase">Select Preferred Time</Label>
                                    <Input id="pref-time" name="pref-time" className="form-control" type="text" value={query && moment(query.prefTime).format('MMMM Do YYYY, h:mm:ss a')} disabled />
                                </FormGroup>
                            </div>
                            <div className="col-md-12">
                                <FormGroup className="form-group">
                                    <Label for="message" className="form-label text-uppercase">Message</Label>
                                    <Input id="message" name="message" type="textarea" className="form-control" rows="5" cols="5" value={query?.message} disabled />
                                </FormGroup>
                            </div>
                            <div className="col-md-12 form-group">
                                <label className="d-block">Status</label>
                                <div className="d-flex flex-wrap">
                                    <div className="mr-3" style={{ display: "flex", alignItems: "center" }}>
                                        <input
                                            className="mr-1"
                                            type="radio"
                                            name="status"
                                            value="PENDING"
                                            onClick={handleOnStatusChange}
                                            checked={status === "PENDING" ? true : false}
                                        />
                                        <label>Pending</label>
                                    </div>
                                    <div className="mr-3" style={{ display: "flex", alignItems: "center" }}>
                                        <input
                                            className="mr-1"
                                            type="radio"
                                            name="status"
                                            value="IN PROGRESS"
                                            onClick={handleOnStatusChange}
                                            checked={status === "IN PROGRESS" ? true : false}
                                        />
                                        <label>In Progress</label>
                                    </div>
                                    <div className="mr-3" style={{ display: "flex", alignItems: "center" }}>
                                        <input
                                            className="mr-1"
                                            type="radio"
                                            name="status"
                                            value="CLOSED"
                                            onClick={handleOnStatusChange}
                                            checked={status === "CLOSED" ? true : false}
                                        />
                                        <label>Closed</label>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <hr className="w-100 mb-4" />
                            </div>
                        </div>
                        <div className="d-flex flex-wrap justify-content-between mb-5">
                            <button className="mb-5 sub-button mt-4 px-4" onClick={() => history.push("/contact-us-queries")}>Back</button>
                            <button
                                type="submit"
                                disabled={disable}
                                className="mb-5 sub-button mt-4 px-4"
                            >
                                {loading && <SyncLoader color={color} loading={loading} css={override} size={11} />}
                                {!loading && "Update"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}

export default EditQueryStatusForm;